import { Controller, Control } from 'react-hook-form';
import { Button } from '../ui/button';
import { InputOTPPattern } from './InputOTPPattern';
import PhoneInput from './PhoneInput';
import { Value } from 'react-phone-number-input';
interface PhoneOtpInputProps {
  control: Control<any>;

  phone: {
    country?: string;
    countryCode: string;
    fullNumber: string;
    phoneNumber: string;
  };

  setPhone: (value: any) => void;

  // optional OTP features
  showOtpButton?: boolean;
  active?: boolean;
  showOtpField?: boolean;
  timeLeft?: number;

  handleSendOtp?: () => void;
  handleResetOtpField?: () => void;
}
export function PhoneOtpInput({
  control,
  phone,
  setPhone,

  showOtpButton = true,
  active = false,
  showOtpField = false,
  timeLeft = 0,

  handleSendOtp,
  handleResetOtpField,
}: PhoneOtpInputProps) {

  return (
    <div className="space-y-3">
      {/* LABEL */}
      <label className="text-sm text-white">Mobile Number</label>

      {/* PHONE FIELD */}
      <Controller
        name="phone"
        control={control}
        defaultValue=""
        render={({ field, fieldState: { error } }) => (
          <>
            <div
              className="
                flex
                items-center
                gap-2

                rounded-full
                border border-[#616161]

                bg-transparent

              

                transition-all

                focus-within:border-[#FA5629]
                focus-within:ring-2
                focus-within:ring-[#FA5629]/20
              "
            >
              {/* PHONE INPUT */}
              <div className="flex-1 overflow-hidden rounded-full">
                <PhoneInput
                  value={field.value as Value}
                  disabled={active}
                  onChange={(phoneData: any) => {
                    setPhone(phoneData);

                    field.onChange(phoneData.fullNumber);
                  }}
                />
              </div>

              {/* OTP BUTTON */}
              {showOtpButton && (
                <Button
                  type="button"
                  disabled={!field.value || !!error}
                  onClick={active ? handleResetOtpField : handleSendOtp}
                  className="
                  h-11
                  rounded-r-full

                  bg-[#FA5629]
                  px-5

                  text-white

                  hover:bg-[#ff6b3d]
                "
                >
                  {!active ? 'Sent OTP' : 'Change'}
                </Button>
              )}
            </div>

            {/* ERROR */}
            {error && <p className="text-xs text-red-500">{error.message}</p>}
          </>
        )}
      />

      {/* OTP FIELD */}
      {showOtpField && (
        <div className="space-y-2">
          {/* TIMER */}
          <div className="flex justify-end">
            <button
              type="button"
              disabled={timeLeft > 0}
              onClick={handleSendOtp}
              className="
                text-xs
                text-[#FA5629]
                disabled:opacity-50
              "
            >
              {timeLeft > 0 ? `Resend in ${timeLeft}s` : 'Resend OTP'}
            </button>
          </div>

          {/* OTP INPUT */}
          <Controller
            name="otp"
            control={control}
            rules={{
              required: 'OTP is required',
              minLength: {
                value: 6,
                message: 'OTP must be 6 digits',
              },
            }}
            render={({ field: { onChange, value } }) => (
              <InputOTPPattern
                value={value || ''}
                onChange={onChange}
                timeRemaining={timeLeft}
                onResend={handleSendOtp}
              />
            )}
          />
        </div>
      )}
    </div>
  );
}
